import { dwCollect } from '@/utils/dw-collect';

/**
 * 提示条展示
 */
export const dwTemplateGuideShow = () => {
  dwCollect({ module: 'tip', action: 'show' });
};

/**
 * 关闭提示条
 */
export const dwTemplateGuideCloseClick = () => {
  dwCollect({ module: 'tip', element: 'close', action: 'click' });
};
